import clsx from "clsx";

import { PERIOD_OPTIONS } from "../../../../../constants/time-allocation.ts";
import type { AllocationPeriodUi } from "../../../../../types/time-allocation.ts";

import styles from "./allocation-period-toggle.module.css";

export type AllocationPeriodToggleProps = {
  value: AllocationPeriodUi;
  onChange: (next: AllocationPeriodUi) => void;
  ariaLabelledBy?: string;
  currentLabel?: string | null;
};

export function AllocationPeriodToggle({
  value,
  onChange,
  ariaLabelledBy,
  currentLabel,
}: AllocationPeriodToggleProps) {
  return (
    <div className={styles.wrapper}>
      {currentLabel != null && currentLabel !== "" ? (
        <span className={clsx("body-sm", styles.currentLabel)}>{currentLabel}</span>
      ) : null}
      <div
        className={styles.root}
        role="radiogroup"
        aria-labelledby={ariaLabelledBy}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
      {PERIOD_OPTIONS.map((opt) => {
        const selected = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={clsx("body-sm", styles.segment, selected && styles.segmentSelected)}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
      </div>
    </div>
  );
}
